import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aed9b42"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips fl" }, "仅保留最近30天的任务", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 刷新 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 下载 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 重新导出 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 取消 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 确定 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ReportTable = _resolveComponent("ReportTable")!
  const _component_AdminTableLayout = _resolveComponent("AdminTableLayout")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    ref: "formDialogRefs",
    title: "下载中心",
    width: "800px",
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visibleRef) = $event))
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        class: "system-btn",
        size: "mini",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visibleRef = false))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "system-btn",
        type: "primary",
        size: "mini",
        loading: _ctx.loading,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visibleRef = false))
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_AdminTableLayout, {
        needSearchForm: false,
        isDialog: true,
        style: {"height":"450px"}
      }, {
        "content-header": _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_el_button, {
            class: "system-btn fr",
            type: "primary",
            size: "mini",
            loading: _ctx.loading,
            onClick: _ctx.requestTableData
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]),
        "content-table": _withCtx(() => [
          _createVNode(_component_ReportTable, {
            loading: _ctx.loading,
            tableData: _ctx.tableData,
            showTableColumn: _ctx.showTableColumn
          }, {
            actions: _withCtx(({ row }) => [
              (row.fileStatus == 1)
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 0,
                    type: "primary",
                    onClick: ($event: any) => (_ctx.handleDownload(row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (row.fileStatus == 2)
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 1,
                    type: "primary",
                    onClick: ($event: any) => (_ctx.handleReExport(row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading", "tableData", "showTableColumn"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}